import React from 'react';
import { List } from '@material-ui/core';

import NavigationItem from './NavigationItem';

const navigationMenu = ({ component, indented, menuItems }) => {
    return (
        <List>
            {menuItems.map(item => <NavigationItem key={item.text} component={component} indented={indented} {...item} />)}
        </List>
    );
}

export default navigationMenu;